import React, {useEffect, useState} from 'react'
import moment from 'moment';
import {useHistory} from 'react-router-dom';
import {collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, updateDoc, where} from "firebase/firestore";
import {getDb} from 'util/Constants';
import Swal from "sweetalert2";
import {Button, Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';

import PopupForm from '../reusable/popupForm';

const colors = [
  "linear-gradient(to bottom right, #FFCC33, #FF9933)",
  "linear-gradient(to bottom right, #66CCCC, #33CCFF)",
  "linear-gradient(to bottom right, #FF66CC, #FF3399)",
  "linear-gradient(to bottom right, #99CC99, #66CC99)",
  "linear-gradient(to bottom right, #FF9966, #FF6633)"
];

const styles = {
  card: {
    backgroundColor: '#fff0',
    border: 'none'
  },
  card2: {
    border: 'none',
  },
  buttonspos: {
    marginTop: "50px"
  }

}

export default function Assessments() {
  const db = getDb();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [eventId, setEventId] = useState("");
  const [events, setEvents] = useState([]);
  const [eventData, setEventData] = useState({});
  const [loading, setLoading] = useState(null);
  const [buttonLoad, setButtonLoad] = useState(false);
  const history = useHistory()

  useEffect(() => {
    const fetch = async () => {
      await getEvents()
    }
    fetch()
  }, [])

  const getEvents = async () => {
    setLoading(null)
    const eventRef = collection(db, "Events");
    const querySnapshot = await getDocs(eventRef);
    let arr = [];

    querySnapshot.forEach((doc) => {
      arr.push({ id: doc.id, ...doc.data() })
    });
    setEvents(arr);
    setLoading("fetched")
  }

  const toggleModal = (event) => {
    setEventData(event)
    setIsModalOpen(!isModalOpen);
  };

  const handleDelete = (event) => {
    // onDelete(event.id);
  };


  const toggleCreateModal = () => {
    setCreateModal(!createModal)
  }



  const createEvent = async (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Progress Assessment Setup!",
      html:
        '<div class="swal2-text">' +
        '<p> Welcome to Progress Assessment setup admin portal. You will be required some information to fill in order ' +
        'to setup a Progress Assessment. Please follow go through all screens 1 by 1 and fill in required ' +
        'information.</p>' +
        '<p>Each gage event consists of following options, enable what suits your needs:</p>' +
        '<ol class="text-start">' +
        '<li>Event formation groups or individuals</li>' +
        '<li>Basic entry field selection</li>' +
        '<li>Avatar flow as per your topic with 1 to 4 screens</li>' +
        '<li>Super powers or special competencies selection</li>' +
        '<li>Individual voting option on any topic</li>' +
        '<li>Group or individual Questions & surveys</li>' +
        '</ol>' +
        '</div>',
      width: 700,
      confirmButtonText: "Let’s go",
      confirmButtonColor: "#2b900e"
    }).then(async (result) => {
      if (result.isConfirmed) {
        toggleCreateModal();
        generateEventId().then(result => {
          setEventId(result);
        });
      }
    })
  };
  const saveEventInfo = async (_eventData) => {
    try {
      await updateDoc(doc(db, "Events", _eventData.id), {
        ..._eventData
      })

      toggleModal();
      await getEvents()
      // props.setEventData(_eventData);
    } catch (e) {
    }
  }


  const saveInfo = async (_eventData) => {
    try {
      await setDoc(doc(db, "Events", eventId), {
        ..._eventData
      })
      toggleCreateModal();
      history.push(`/admin/leaderboard/${eventId}`)
    } catch (e) {
    }
  }


  const generateEventId = async () => {
    const _eventId = Math.floor(1000 + Math.random() * 9000).toString();
    const docRef = doc(db, "event", _eventId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      await generateEventId();
    } else {
      return _eventId;
    }
  }

  const deleteEvent = async (event) => {
    setButtonLoad(event.id)
    await deleteDoc(doc(db, "Events", event.id));
    const usersDocRef = collection(db, "users");
    const usersQuery = query(usersDocRef, where("eventID", "==", event.id));
    const usersSnapshot = await getDocs(usersQuery);
    for (let i = 0; i < usersSnapshot.docs.length; i++) {
      await deleteDoc(usersSnapshot.docs[i].ref);
    }

    const EventsFilter = events.filter((e) => e.id !== event.id)
    setEvents(EventsFilter)


    setButtonLoad(false)
  }



  return (
    <>
      {loading === null ?
        <div className="text-center w-100 py-5 my-5">
          <div className="spinner-border spinner-border-lg" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div> : (
          <>
            <div className="header  pb-8 pt-5 pt-md-8" />
            <Container className="mt--9" fluid>
              <Card className='mb-5' style={styles.card}>
                <h2 className='zindex-tooltip position-relative text-white'>Select an Assessment</h2>
                <div className="d-flex w-100 justify-content-end align-items-center">
                  <div className="w-50">
                    {/* <Input type="text" className="plainInput float-end"
                      placeholder="Search by Event Name or Id"
                      onChange={""} value={''} /> */}
                  </div>
                  <div>
                    {<Button color="success" className="ml-2" onClick={createEvent}>
                      + Create Assessment
                    </Button>}
                  </div>
                </div>
              </Card>
              <Row className="mb-4">
                {events.map((event, i) => (
                  <Col md={6} className="mb-3" key={event.id}>
                    <Card style={{ border: "none", backgroundImage: colors[(i % colors.length + colors.length) % colors.length] }} className="text-white pb-3">
                      <CardBody className="py-0">
                        <div className="d-flex justify-content-between mt-3">
                          <h3 className="fw-bold text-white">
                            {event.assessmentName}
                          </h3>
                          <p className="mb-0">{moment(event.LaunchDate).format('dddd, MMMM Do, YYYY')}</p>
                        </div>

                        <Row>
                          <Col md={3} className="py-0">
                            <div>
                              <img
                                alt=""
                                className="rounded "
                                width={140}
                                height={140}
                                src={event.logo}
                              />
                            </div>
                            <div className="mt-3">
                              {/* <img
                        alt=""
                        className="rounded"
                        width={140}
                        height={25}
                        src={'https://www.activ8games.com/images/activ8gamelogo.png'}
                      /> */}
                            </div>
                          </Col>
                          <Col md={1} />
                          <Col md={8}>
                            <div className="w-100 d-flex justify-content-between">
                              <span className="text-white">Assessment ID</span>
                              <span className="text-white mx-2">{event.id}</span>
                            </div>
                            <div
                              className="w-100 d-flex justify-content-between  rounded mt-1">
                              <span className="text-white">Assessment For</span>
                              <span
                                className="text-white mx-2">{event.assessmentFor}</span>
                            </div>
                            <div style={styles.buttonspos} className="d-flex justify-content-end">

                              <Button className="btn-sm btn-success my-2 mx-2"
                                onClick={() => toggleModal(event)}
                              >
                                Edit
                              </Button>

                              <Button disabled={buttonLoad === event.id} onClick={() => deleteEvent(event)} className="btn-sm btn-warning my-2 ms-2"
                              >

                                {buttonLoad === event.id ? <>
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                  <span class="sr-only">Loading...</span>
                                </> : "Delete"}
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                ))

                }        </Row>
            </Container>
            <Modal isOpen={createModal} toggle={toggleCreateModal} backdrop={false}>
              <ModalHeader className="textColor">Create Event</ModalHeader>
              <ModalBody style={{ overflowY: "auto" }}>
                <PopupForm eventData={{}} setIsEditForm={setCreateModal} mainEventId={eventId}
                  setMainData={saveInfo}
                />
              </ModalBody>
            </Modal>
            <Modal isOpen={isModalOpen} toggle={toggleModal}>
              <ModalHeader toggle={toggleModal}>Edit Event</ModalHeader>
              <ModalBody style={{ overflowY: "auto" }}>
                <PopupForm eventData={eventData} setIsEditForm={setIsModalOpen} setMainData={saveEventInfo}
                  mainEventID={eventData?.id} />
              </ModalBody>
            </Modal>
          </>
        )
      }
    </>
  )
}
